import { Icon } from "~/ui-library";
import { ArrowUturnRightIcon } from "~/ui-library/icons";

export const SocialMediaShareFlyoutButton: React.FC<{
  className: string;
  onClick: (() => void) | undefined;
}> = ({ className, onClick, ...rest }) => (
  <button className={className} onClick={onClick} {...rest}>
    <div className="flex items-center justify-center gap-xxs font-semibold">
      <Icon className="fill-transparent" SvgIcon={ArrowUturnRightIcon} />
      Share
    </div>
  </button>
);
